import React from "react";
// types
import { TMainPageLayoutV2 } from "../type";


const MNPG004 = ( props: TMainPageLayoutV2 ) => {
    console.log("MNPG004.rendered", props);

    return null;
}

const Component = React.memo(MNPG004, ( prevProps:TMainPageLayoutV2, nextProps:TMainPageLayoutV2 ) => {
    console.log("MNPG004.memo", { prevProps, nextProps });
    return true;
});

export default Component;
